/* eslint-disable */
import { GetterTree } from "vuex";
import { Partner } from "@/models/partner";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { PartnerState } from "@/types/partner";

const getters: GetterTree<PartnerState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new Partner();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((partner) => Partner.toSelectItem(partner))
      : [];
  },
  find: (state) => (id: number) => {
    return state.pagination
      ? state.pagination.data.find((partner) => {
          return partner.id == id;
        })
      : new Partner();
  },
};

export default getters;
